import { render, staticRenderFns } from "./SkeletonPersonGeneralInformationGlobal.vue?vue&type=template&id=26385197&scoped=true&"
import script from "./SkeletonPersonGeneralInformationGlobal.vue?vue&type=script&lang=js&"
export * from "./SkeletonPersonGeneralInformationGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPersonGeneralInformationGlobal.vue?vue&type=style&index=0&id=26385197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26385197",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow,VSkeletonLoader,VSpacer})
